import React from 'react';

const IconSize = {
    Tiny: 'tiny',
    Small: 'small',
    Default: 'default',
    Big: 'big',
    Huge: 'huge',
    Giant: 'giant'
}

export default class Icon extends React.Component {

    static Size = IconSize;

    state = {
        hover: false
    }

    static defaultProps = {
        size: IconSize.Default
    }

    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick()
        }
    }

    onMouseEnter = () => {
        this.setState({hover: true})
    }

    onMouseLeave = () => {
        this.setState({hover: false})
    }

    render() {
        return (
            <div className="icon" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
                 onClick={this.onClick}>
                {this.renderIcon()}
            </div>
        )
    }

    renderIcon() {
        return <React.Fragment></React.Fragment>;
    }

    getSize() {
        if (this.props.size) {
            switch (this.props.size) {
                case IconSize.Tiny:
                    return 8;
                case IconSize.Small:
                    return 12;
                case IconSize.Default:
                    return 16;
                case IconSize.Big:
                    return 24;
                case IconSize.Huge:
                    return 28;
                case IconSize.Giant:
                    return 48;
            }
        }

        return 16;
    }
}